import { Session } from "@supabase/supabase-js";
import { StateCreator } from "zustand";
import { ProfileRow } from "api/profile";

export interface UserAuth {
  // FIXME: uid should be number
  id: number;
  email?: string;
  profileCreated: boolean;
  provider?: string;
}

export interface UserSlice {
  user: {
    auth: UserAuth | null;
    profile: ProfileRow | null;
    session: Session | null;
    set: (setting: Omit<Partial<UserSlice["user"]>, "set">) => void;
  };
}

const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (set) => ({
  user: {
    auth: null,
    profile: null,
    session: null,
    set: (user) =>
      set((state) => ({
        user: { ...state.user, ...user },
      })),
  },
});

export default createUserSlice;
